<template>
  <div class="infoboks">
    <div
      class="close-x"
      @click="onClose"
      @mouseover="closeSize = 14"
      @mouseleave="closeSize = 12"
    >
      <IconClose
        :iconName="'Luk'"
        :color="'#ffffff'"
        :width="closeSize"
        :height="closeSize"
      />
    </div>
    <div class="info-body">
      <h2>
        <Advarsel
          :width="24"
          :iconColor="'#fff'"
          :strokeColor="'#BB5CEE'"
        />Bemærk &hellip;</h2>
      <p>… at gemte ruter kan være automatisk opdateret siden de blev gemt.</p>
    </div>
  </div>
</template>

<script>
import IconClose from '@/components/Icons/Close.vue';
import Advarsel from '@/components/Icons/Advarsel.vue';
export default {
  name: 'InfoBoks',
  components: {
    IconClose,
    Advarsel,
  },
  props: {
    onClose: Function,
  },
  data() {
    return {
      closeSize: 12,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.infoboks {
  position: fixed;
  z-index: 10;
  right: 10px;
  bottom: 10px;
  background-color: #bb5cee;
  background: #bb5cee;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.25);
  color: #fff;
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  opacity: 0;
  animation-name: fadein;
  animation-duration: 0.3s;
  /* animation-delay: 1s; */
  animation-fill-mode: forwards;
  .info-body {
    margin: -40px 40px 20px 40px;
    //flex: 1; /* flex: 1 (med implisit sat flex-shrink, fører til at boksen krymper pga flexbox nesting issue i IE11. */
    width: 270px; /* Ellers spiller teksten ud over boksen i IE11 */

    h2 {
      font-weight: 700;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      svg {
        margin-right: 10px;
      }
    }
    p {
      opacity: 0.8;
      font-size: 15px;
    }
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.close-x {
  align-self: flex-end;
  margin: 20px;
  cursor: pointer;
}
.close-x:hover {
  margin: 22px 19px 20 20;
}

@media only screen and (max-width: $mobile-max-width) {
  .infoboks {
    width: 95%;
    width: calc(100% - 20px);
    right: 0;
    bottom: 0;
    margin: 10px;
    display: none;
  }
}
</style>
